import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";

const slice = createSlice({
    name: "wfApp",
    initialState: {
        list: [],
        loading: false,
        lastFetch: null,
        appSummary: "",
        appUpdates: [],
        allAppDocs: [],
        appDefaultData: "",
        appData: "",
        appStartedData: "",
        summaryBprmForm: null,
        wfAppTasks: [],
        clientAllApps: [],
        tskDoneStatus: [],
    },
    reducers: {
        appDefaultDataReceived: (wfApp, action) => {
            wfApp.appDefaultData = action.payload;
        },
        appReceived: (wfApp, action) => {
            wfApp.appData = action.payload;
        },
        appDocumentReceived: (wfApp, action) => {
            wfApp.allAppDocs = action.payload;
        },
        wfAppTasksReceived: (wfApp, action) => {
            wfApp.wfAppTasks = action.payload;
        },
        clientAllAppsReceived: (wfApp, action) => {
            wfApp.clientAllApps = action.payload;
        },
        taskDone: (wfApp, action) => {
            wfApp.tskDoneStatus = action.payload;
            wfApp.currentWfTask = "";
        },
    }
});

export const { appDefaultDataReceived, appReceived,
    wfAppTasksReceived, clientAllAppsReceived, taskDone,appDocumentReceived } = slice.actions;
export default slice.reducer;

const getWfAppDefaultData = "";
const getWfAppData = "WfApplication/GetApplication?id=";
const getWfAppTasks = "WfApplication/GetWorkflowTasks";
const getAllAppDocs = "WfApplication/GetAllAppDocuments";
const getWfAllApps = "WfApplication/GetAllAppNames?clientId=";
const setWorkItemToDone = "WfApplication/WfTaskDone?wiid=";

export const loadAppDefaultData = (id) => apiCallBegan({
    url: getWfAppDefaultData + id,
    onSuccess: appDefaultDataReceived.type
});

export const loadApplication = (id, clientId) => apiCallBegan({
    url: getWfAppData + id + "&clientId=" + clientId,
    onSuccess: appReceived.type
});

export const loadAppWfTasks = (data) => apiCallBegan({
    url: getWfAppTasks,
    method: "POST",
    data: data,
    onSuccess: wfAppTasksReceived.type
});

export const loadAllAppDocuments = (data) =>
  apiCallBegan({
    url: getAllAppDocs,
    method: "POST",
    data: data,
    onSuccess: appDocumentReceived.type,
  });

export const wfTaskDone = (wiid, clientId) => apiCallBegan({
    url: setWorkItemToDone + wiid + "&clientId=" + clientId,
    //method: "post",
    //data: data,
    onSuccess: taskDone.type
});

export const loadClientAllApps = (id) => apiCallBegan({
    url: getWfAllApps + id,
    onSuccess: clientAllAppsReceived.type
});

export const getAppDefaultData = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.appDefaultData
);

export const getApplication = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.appData
);

export const getAppWfTasks = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.wfAppTasks
);

export const getAllAppDocuments = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.allAppDocs
);

export const getClientAllApps = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.clientAllApps
);

export const getTaskDoneStatus = createSelector(
    state => state.entities.wfApp,
    wfApp => wfApp.tskDoneStatus
);

